import { extendBaseTheme } from "@chakra-ui/react";

export const theme = extendBaseTheme({
  components: {},
});
